export interface AssignedUserDto {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
}

export interface RoleWithUsersDto {
  roleId: string;
  roleName: string;
  isadmin: boolean;
  description: string;
  assignedUsers: AssignedUserDto[];
  totalUsers: number;
  isImported?: boolean;
  isExternal?: boolean;
  roleSource?: number;
  externalProvider?: string;
}
export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  isActive: boolean;
  isImported?: boolean;
  isExternal?: boolean;
  externalProvider?: string;
}

export const isExternalRole = (role: {
  isExternal?: boolean;
  isImported?: boolean;
  roleSource?: number;
}) => !!(role.isExternal || role.isImported || role.roleSource === 1);

export const isExternalUser = (user: {
  isExternal?: boolean;
  isImported?: boolean;
}) => !!(user.isExternal || user.isImported);

export type PortalAccessStatus = 'none' | 'invited' | 'active' | 'suspended';

export interface NamedRefDto {
  id: string;
  name: string;
}

export interface UserManagerDto {
  id: string;
  name: string;
  email?: string;
}

export interface UserDetailDto {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string | null;
  tenantId: string;
  roleID: string;
  roleId: string;
  roleName: string;
  isadmin?: boolean;
  isActive: boolean;
  portalAccessStatus: PortalAccessStatus;
  emailConfirmed: boolean;
  loginType: string;
  lastLoginAt?: string | null;
  createdAt?: string | null;
  department?: NamedRefDto | null;
  isImported?: boolean;
  isExternal?: boolean;
  externalProvider?: string | null;
  externalProviderUserId?: string | null;
  directoryStatus?: string | null;
  directoryConnection?: NamedRefDto | null;
  lastSyncedAt?: string | null;
  syncEnabled?: boolean;
  jobTitle?: string | null;
  officeLocation?: string | null;
  employeeId?: string | null;
  manager?: UserManagerDto | null;
}
